type GoogleMapEmbedProps = React.IframeHTMLAttributes<HTMLIFrameElement> & {
  lat: number;
  lng: number;
  zoom?: number;
};

export function GoogleMapEmbed({ lat, lng, zoom = 14, ...props }: GoogleMapEmbedProps) {
  const src = `https://www.google.com/maps?q=${lat},${lng}&output=embed`;

  return (
    <iframe
      title="Google Map Embed"
      src={src}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      allowFullScreen
      className="w-full rounded-lg border-0 bg-blank"
      {...props}
    />
  );
}
